module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dane ogólne")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Data obowiązywania",
      "error": _vm.errors['date']
    }
  }, [_c('date-picker', {
    model: {
      value: (_vm.priceList.date),
      callback: function($$v) {
        _vm.priceList.date = $$v
      },
      expression: "priceList.date"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dla sprzedających")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Pozycje cennika"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Rodzaj pojazdu")]), _vm._v(" "), _c('td', [_vm._v("Cena")]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.priceList.forSellers), function(item) {
    return _c('tr', [_c('td', [_c('text-input', {
      model: {
        value: (item.type),
        callback: function($$v) {
          item.type = $$v
        },
        expression: "item.type"
      }
    })], 1), _vm._v(" "), _c('td', [_c('text-input', {
      model: {
        value: (item.price),
        callback: function($$v) {
          item.price = $$v
        },
        expression: "item.price"
      }
    })], 1), _vm._v(" "), _c('td', [_c('question-button', {
      staticClass: "btn btn-danger",
      attrs: {
        "question": "Czy na pewno usunąć pozycję?"
      },
      on: {
        "click": function($event) {
          _vm.removePosition(_vm.priceList.forSellers, item)
        }
      }
    }, [_c('trash-icon'), _vm._v("\n                Usuń pozycję\n              ")], 1)], 1)])
  }))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addPosition(_vm.priceList.forSellers)
      }
    }
  }, [_vm._v("Dodaj pozycję")])])], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dla kupujących")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Pozycje cennika"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Rodzaj pojazdu")]), _vm._v(" "), _c('td', [_vm._v("Cena")]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.priceList.forBuyers), function(item) {
    return _c('tr', [_c('td', [_c('text-input', {
      model: {
        value: (item.type),
        callback: function($$v) {
          item.type = $$v
        },
        expression: "item.type"
      }
    })], 1), _vm._v(" "), _c('td', [_c('text-input', {
      model: {
        value: (item.price),
        callback: function($$v) {
          item.price = $$v
        },
        expression: "item.price"
      }
    })], 1), _vm._v(" "), _c('td', [_c('question-button', {
      staticClass: "btn btn-danger",
      attrs: {
        "question": "Czy na pewno usunąć pozycję?"
      },
      on: {
        "click": function($event) {
          _vm.removePosition(_vm.priceList.forBuyers, item)
        }
      }
    }, [_c('trash-icon'), _vm._v("\n                Usuń pozycję\n              ")], 1)], 1)])
  }))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addPosition(_vm.priceList.forBuyers)
      }
    }
  }, [_vm._v("Dodaj pozycję")])])], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d29795b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PriceList.vue
// module id = 468
// module chunks = 1